import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateHobbiesSimple = () => {
  const history = useHistory();
  const { id } = useParams();

  const hobbiesList = [
    "Bikes / Car",
    "Cooking",
    "Dancing",
    "Fashion design",
    "Gardening",
    "Long drives",
    "Painting",
    "Pets",
    "Photography",
    "Politics",
    "Shopping",
    "Singing",
    "Social media",
    "Social services",
    "Travel / Touring",
    "Video / computer gaming",
    "Writing",
    "Music",
    "Books Reading",
    "Movies",
    "Sports",
    "Fitness / Gym",
  ];

  const [selectedHobbies, setSelectedHobbies] = useState([]);

  const isHobbySelected = (hobby) => {
    return selectedHobbies.some(
      (selected) => selected.toLowerCase().trim() === hobby.toLowerCase().trim()
    );
  };

  const handleHobbyToggle = (hobby) => {
    if (isHobbySelected(hobby)) {
      setSelectedHobbies(selectedHobbies.filter(
        (h) => h.toLowerCase().trim() !== hobby.toLowerCase().trim()
      ));
    } else {
      setSelectedHobbies([...selectedHobbies, hobby]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      hobbies: selectedHobbies.join(", "),
    };

    api
      .post("/admin/userProfile/hobbiesUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Hobbies updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update hobbies", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const userDetails = d.userDetails || {};
        if (userDetails.hobbies) {
          const hobbies = userDetails.hobbies.split(/,\s*/).map((h) => h.trim()).filter(h => h);
          setSelectedHobbies(hobbies);
        }
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load hobbies", "error");
      });
  }, [id]);

  const chipStyle = (isSelected) => ({
    display: "inline-block",
    padding: "10px 20px",
    margin: "8px",
    borderRadius: "25px",
    border: isSelected ? "none" : "1.5px solid #757575",
    backgroundColor: isSelected ? "#000" : "#fff",
    color: isSelected ? "#fff" : "#333",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    transition: "all 0.2s ease",
    userSelect: "none",
  });

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Hobbies & Interests</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <div style={{ marginBottom: "20px" }}>
          <p style={{ color: "#212121", fontWeight: "800", marginBottom: "15px" }}>
            Select Your Hobbies
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
            {hobbiesList.map((hobby, index) => (
              <div
                key={index}
                style={chipStyle(isHobbySelected(hobby))}
                onClick={() => handleHobbyToggle(hobby)}
              >
                {hobby}
              </div>
            ))}
          </div>
        </div>

        {selectedHobbies.length > 0 && (
          <div style={{ 
            marginTop: "20px", 
            padding: "15px", 
            backgroundColor: "#f5f5f5", 
            borderRadius: "12px",
            border: "1.5px solid #757575"
          }}>
            <p style={{ fontWeight: "800", marginBottom: "10px", color: "#212121" }}>Selected Hobbies:</p>
            <p style={{ color: "#333", fontWeight: "bold" }}>{selectedHobbies.join(", ")}</p>
          </div>
        )}

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
            marginTop: "30px",
          }}
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default UpdateHobbiesSimple;
